﻿import {Injectable,Inject} from 'ng-metadata/core';
import { STATE_NAMES } from "../primoExplore/primoExploreStates.module";


@Injectable()
export class DatabasesService {


    constructor(@Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService){

    }

    public isDBSearch() {
       return (this.$state.current.name === STATE_NAMES.DB_SEARCH ||
            this.$state.current.name ===STATE_NAMES.DB_FULL_DISPLAY)
    }






}





// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/databases.service.ts